/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { apiAddress, apiAddressList } from '@/api';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
export default {
  components: {
    ViewBox: ViewBox,
    Popup: Popup,
    AddressAdd: function AddressAdd() {
      return import('@/pages/mine/address/add');
    }
  },
  props: {
    isChiose: Boolean
  },
  data: function data() {
    return {
      isShowAddress: false,
      list: null,
      selected: false
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    chioseAddress: function chioseAddress(item) {
      if (this.isChiose) {
        this.$emit('on-chiose', item);
      }
    },
    getList: function getList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return apiAddressList();
              case 2:
                res = _context.sent;
                if (res.success) {
                  _this.list = res.data;
                } else {
                  _this.$vux.toast.text(res.message);
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    setDefault: function setDefault(id) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$vux.loading.show({
                  text: i18n.tc("632")
                });
                _context2.next = 3;
                return apiAddress({
                  id: id
                }, 'put');
              case 3:
                res = _context2.sent;
                setTimeout(function () {
                  _this2.$vux.loading.hide();
                }, 300);
                if (res.success) {
                  _this2.getList();
                } else {
                  _this2.$vux.toast.text(res.message);
                }
              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    delAddress: function delAddress(id) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this3.$vux.confirm.show({
                  title: i18n.tc("280"),
                  content: i18n.tc("633"),
                  hideOnBlur: true,
                  onConfirm: function () {
                    var _onConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                      var res;
                      return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              _context3.next = 2;
                              return apiAddress({
                                id: id
                              }, 'delete');
                            case 2:
                              res = _context3.sent;
                              if (res.success) {
                                _this3.getList();
                              } else {
                                _this3.$vux.toast.text(res.message);
                              }
                            case 4:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3);
                    }));
                    function onConfirm() {
                      return _onConfirm.apply(this, arguments);
                    }
                    return onConfirm;
                  }()
                });
              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};